import { useMemo } from 'react';
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import Paper from "@mui/material/Paper";
import Fade from "@mui/material/Fade";
import NavigationBar from "../../../features/navigation-bar";
import styles from "./styles";
import SplashScreen from "../../LoadingPagePreview/SplashScreen"; // Імпортуйте SplashScreen
import { withStyles } from 'tss-react/mui';
export default function wrapPage(Component) {
  const Page = (props) => {
    const {
      classes,
      isLoading = false,
      isPushing = false,
      didLoad = true,
      onSignOut = () => false,
    } = props;
    const isDataEmpty = isEmpty(props.data);

    const showSplashScreen = useMemo(
      () => (isLoading || isPushing) && isDataEmpty && !didLoad,
      [isLoading, isPushing, isDataEmpty, didLoad]
    );

    return (
      <section className={classes.root}>
        <NavigationBar
          isLoading={isLoading || isPushing}
          onSignOut={onSignOut}
        />
        {showSplashScreen ? (
          <SplashScreen />
        ) : (
          <Fade in={didLoad}>
            <Paper elevation={0} className={classes.contentWrapper}>
              <Component {...props} isDataEmpty={isDataEmpty} />
            </Paper>
          </Fade>
        )}
      </section>
    );
  };

  Page.propTypes = {
    isLoading: PropTypes.bool,
    isPushing: PropTypes.bool,
    didLoad: PropTypes.bool,
    onSignOut: PropTypes.func,
    classes: PropTypes.object.isRequired,
  };

  return withStyles(Page, styles);
}
